export default "__VITE_ASSET__2STv9Gdh__"